import * as React from "react";
import classNames from "../../../utilities/class-names";

const SfNewWindowIcon = ({ className }) => {
    return <svg className={classNames('docs-icon', className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g>
            <polygon points="11,1 11,2 13.273,2 7.668,7.666 8.379,8.368 14,2.687 14,5 15,5 15,1" />
            <polygon points="14,14 2,14 2,2 8,2 8,1 1,1 1,15 15,15 15,8 14,8" />
        </g>
    </svg>;
}

export default SfNewWindowIcon;